import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
	const locales = require.context('./', true, /[A-Za-z0-9-_,\s]+\.json$/i)
	const messages = {}
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = locales(key)
		}
	})
	return messages
}

const i18n = new VueI18n({
	locale: 'ar',
	fallbackLocale: 'ar',
	messages: loadLocaleMessages()
})

export const changeLang = (lang) => {
	i18n.locale = lang
	localStorage.setItem('locale', lang)
	document.documentElement.lang = lang
	if (lang === 'ar') {
		document.documentElement.dir = 'rtl'
	} else {
		document.documentElement.dir = 'ltr'
	}
}

if ('locale' in localStorage) {
	changeLang(localStorage.getItem('locale'))
} else {
	changeLang('ar')
}

export default i18n